export default {
      MyAccounts: 'الإشعار|حسابي - الإشعارات',
      MyAccounts_no_body: 'إشعار',
};
